import { colors as uiColors } from '@cobliteam/ui/theme';
import { css } from 'emotion';

import { colors, icons } from '@cobliteam/base-components/src/styles';

export const popper = css`
  && {
    min-width: 200px;
    padding: 10px 0px;
    margin-left: -10px;
    border-radius: 0px;
    border-width: 0;
    background-color: ${uiColors.gray[12]};
    align-items: center;

    max-height: 100vh;
    overflow: auto;
  }
`;

export const sidebarItem = css`
  display: flex;
  align-items: center;
  height: 50px;
  cursor: pointer;
  white-space: nowrap;
  &:hover {
    background-color: ${uiColors.white.a2};
  }

  &a:-webkit-any-link {
    text-decoration: none;
  }
`;

export const iconWrapper = (active: boolean): string => css`
  padding: 17px 34px;
  color: ${active ? colors.primary.default : colors.white};
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;

  & > svg {
    font-size: ${icons.size.small};
  }
`;

export const fleetSelectedIcon = (active: boolean): string => css`
  padding: 20px 20px 20px 40px;
  color: ${active ? colors.primary.default : colors.white};
  margin-left: auto;

  & > svg {
    font-size: ${icons.size.smallest};
  }
`;

export const menuItem = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;
